import '../../monitoring/filters/applied_boolean_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.AppliedBooleanView extends Monitoring.Views.SocialContents.Filters.AppliedBooleanView
  initialize: ({searchQuery, title}) ->
    super(
      searchQuery: searchQuery
      title: title
      trueField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'boolean_true'
        title: I18n.t('monitoring.taxonomy.y')
      falseField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'boolean_false'
        title: I18n.t('monitoring.taxonomy.n')
    )

  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
